import PropTypes from 'prop-types';
import styled from 'styled-components';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
//@ts-expect-error untyped-file
import { getAnyCompanyLogo } from 'conversations-internal-schema/chat-heading-config/operators/getAnyCompanyLogo';
//@ts-expect-error untyped-file
import { hasUserAndTeamResponders } from 'conversations-internal-schema/chat-heading-config/operators/hasUserAndTeamResponders';
import { getAvatar, getFriendlyOrFormalName } from 'conversations-internal-schema/responders/operators/responderGetters';
//@ts-expect-error untyped-file
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import ChatHeadingConfigPropType from 'conversations-prop-types/prop-types/ChatHeadingConfigPropType';
//@ts-expect-error untyped-file
import KnowledgeBaseThreadListHeader from '../../visitor-widget/components/KnowledgeBaseThreadListHeader';
import { useChatWidgetLocale } from '../../visitor-widget/ChatWidgetLocaleContext';
import VizExAvatar from 'visitor-ui-component-library/avatar/VizExAvatar';
import VizExCard from 'visitor-ui-component-library/card/VizExCard';
import ThreadListItemWrapper from '../../threads-list/ThreadListItemWrapper';
import ThreadPreviewText from '../../threads-list/ThreadPreviewText';
import { THREAD_LIST } from '../../visitor-widget/constants/views';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CardsListWrapper = styled.div.withConfig({
  displayName: "ThreadListPreview__CardsListWrapper",
  componentId: "sc-1glpu5f-0"
})(["padding:12px;background-color:#f5f8fa;height:100%;display:flex;flex-direction:column;scrollbar-width:none;"]);
export const ThreadsCardTitle = styled.div.withConfig({
  displayName: "ThreadListPreview__ThreadsCardTitle",
  componentId: "sc-1glpu5f-1"
})(["padding:20px 20px 10px 20px;display:flex;justify-content:space-between;align-items:flex-end;"]);
export const CardTitleText = styled.h5.withConfig({
  displayName: "ThreadListPreview__CardTitleText",
  componentId: "sc-1glpu5f-2"
})(["margin-bottom:0;"]);
const ThreadListWrapper = styled.div.withConfig({
  displayName: "ThreadListPreview__ThreadListWrapper",
  componentId: "sc-1glpu5f-3"
})(["padding:0px;"]);
const AvatarWrapper = styled.div.withConfig({
  displayName: "ThreadListPreview__AvatarWrapper",
  componentId: "sc-1glpu5f-4"
})(["flex-grow:0;margin-right:0px;display:flex;align-items:center;"]);
const CustomUIAvatar = styled(VizExAvatar).withConfig({
  displayName: "ThreadListPreview__CustomUIAvatar",
  componentId: "sc-1glpu5f-5"
})(["border-radius:50%;background:", ";"], props => props.borderColor);
const Card = styled(VizExCard).withConfig({
  displayName: "ThreadListPreview__Card",
  componentId: "sc-1glpu5f-6"
})(["box-shadow:none;h2{font-weight:600;font-size:14px;line-height:24px;margin:0px;}"]);
function ThreadListPreview({
  chatHeadingConfig,
  responder,
  onPressStartNewChatButton,
  initialMessage,
  coloring: {
    accentColor,
    textColor
  },
  isUngatedForKBInWidget,
  widgetView
}) {
  const locale = useChatWidgetLocale();
  const showThreadListOnly = isUngatedForKBInWidget && widgetView === THREAD_LIST;
  const renderAvatar = () => {
    const defaultAgentName = I18n.text('conversations-visitor-experience-components.default.agent');
    if (hasUserAndTeamResponders(chatHeadingConfig)) {
      const altText = I18n.text('conversations-visitor-experience-components.default.avatar', {
        identifier: getFriendlyOrFormalName(responder) || defaultAgentName
      });
      return /*#__PURE__*/_jsx(AvatarWrapper, {
        children: /*#__PURE__*/_jsx(VizExAvatar, {
          src: getAvatar(responder) || '',
          size: "md",
          alt: altText,
          style: {
            height: '40px',
            width: '40px'
          }
        })
      });
    } else {
      const altText = I18n.text('conversations-visitor-experience-components.default.avatar', {
        identifier: chatHeadingConfig.get('customChatName') || defaultAgentName
      });
      return /*#__PURE__*/_jsx(AvatarWrapper, {
        children: /*#__PURE__*/_jsx(CustomUIAvatar, {
          size: "md",
          src: getAnyCompanyLogo(chatHeadingConfig),
          alt: altText,
          borderColor: textColor,
          style: {
            height: '40px',
            width: '40px'
          }
        })
      });
    }
  };
  const renderName = () => {
    if (hasUserAndTeamResponders(chatHeadingConfig)) {
      return /*#__PURE__*/_jsx("span", {
        children: getFriendlyOrFormalName(responder)
      });
    }
    return /*#__PURE__*/_jsx("span", {
      children: chatHeadingConfig.get('customChatName')
    });
  };
  const renderTimestamp = () => {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-visitor-experience-components.visitorWidget.threadListCard.oneDayAgo",
      options: {
        locale
      }
    });
  };
  const renderText = () => {
    return /*#__PURE__*/_jsx(ThreadPreviewText, {
      text: initialMessage,
      hasAttachment: false,
      unseenCount: 0,
      hasChatEnded: false
    });
  };

  // eslint-disable-next-line react/display-name
  const KnowledgeBaseCard = ({
    children
  }) => {
    if (showThreadListOnly) {
      return /*#__PURE__*/_jsx(_Fragment, {
        children: children
      });
    }
    return /*#__PURE__*/_jsx(Card, {
      as: "section",
      "aria-label": I18n.text('conversations-visitor-experience-components.visitorWidget.threadListCard.YourChats'),
      children: children
    });
  };
  return /*#__PURE__*/_jsxs(KnowledgeBaseCard, {
    children: [!showThreadListOnly && /*#__PURE__*/_jsx(KnowledgeBaseThreadListHeader, {
      createNewThread: onPressStartNewChatButton,
      typicalResponseTimeMessage: /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'conversations-internal-schema.typicalResponseTime.standardResponses.FEW_MINUTES'
      }),
      accentColor: accentColor
    }), /*#__PURE__*/_jsx(ThreadListWrapper, {
      children: /*#__PURE__*/_jsx(ThreadListItemWrapper, {
        onClick: onPressStartNewChatButton,
        renderAvatar: renderAvatar,
        renderText: renderText,
        nameText: renderName(),
        unseenCount: 0,
        renderTimestamp: renderTimestamp
      })
    })]
  });
}
ThreadListPreview.propTypes = {
  chatHeadingConfig: ChatHeadingConfigPropType.isRequired,
  coloring: PropTypes.object.isRequired,
  initialMessage: PropTypes.string.isRequired,
  onPressStartNewChatButton: PropTypes.func,
  responder: RecordPropType('Responder')
};
ThreadListPreview.displayName = 'ThreadListPreview';
export default ThreadListPreview;